import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl } from '@/constants/urls';
import { workspaceActions } from '../constants';

export function* closeTab({ code }) {
  yield call(listener.closeTab, [codeUrl(urls.WORKSPACE, code)]);
}

export default function* requestsLayout() {
  yield takeEvery(workspaceActions.DESTROY_REQUEST_WORKSPACE, closeTab);
}
